import React from "react";
import InitialChatWindowImage from "../../../assets/initial_chatwindow.png";
import "./NoConversations.scss";

const NoConversations = () => {
  return (
    <div id="no-coversation-layout">
      <div id="no-conversation-content">
        <img src={InitialChatWindowImage} alt="initial-theme" />
        <h2>Agora ficou fácil! Acompanhe suas conversas de onde estiver.</h2>
      </div>
    </div>
  );
};

export default NoConversations;
